import { all } from 'redux-saga/effects';

import loginSaga from './login-saga';
import logoutSaga from './logout-saga';
import resetPasswordSaga from './reset-password-saga';

export default function* rootSaga() {
  yield all([loginSaga(), logoutSaga(), resetPasswordSaga()]);
}
